import React, {useEffect} from 'react';
import {motion} from 'framer-motion';

const PrivacyPolicy = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="pt-32 pb-24 bg-slate-50 min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{opacity: 0, y: 20}}
          animate={{opacity: 1, y: 0}}
          transition={{duration: 0.6}}
          className="bg-white p-10 md:p-16 rounded-[2rem] shadow-sm border border-slate-200"
        >
          <h1 className="text-5xl font-bold text-slate-900 mb-4 font-serif">Privacy Policy</h1>
          <p className="text-base text-slate-500 mb-10 uppercase tracking-widest font-bold">Last Updated: January 2025</p>
          <div className="space-y-8 text-slate-700 font-light leading-relaxed text-lg md:text-xl">
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">1. Introduction</h2>
              <p>
                At MyMD Weight Loss ("we," "our," or "us"), operating at <a href="https://joinmymd.com" className="text-amber-700 underline">joinmymd.com</a>, we respect your privacy and are committed to protecting your personal and health information. This Privacy Policy describes how we collect, use, disclose, and safeguard your information when you visit our website and participate in our programs.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">2. Information We Collect</h2>
              <p className="mb-4">We may collect information about you in a variety of ways, including:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li><strong className="text-slate-900 font-semibold">Personal Data:</strong> Personally identifiable information, such as your name, address, email address, and telephone number.</li>
                <li><strong className="text-slate-900 font-semibold">Health Information:</strong> Current weight, goals, dietary preferences, and other metrics necessary to provide customized weight loss protocols.</li>
                <li><strong className="text-slate-900 font-semibold">Financial Data:</strong> Payment information required to process transactions for our services and programs.</li>
              </ul>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">3. How We Use Your Information</h2>
              <p className="mb-4">Having accurate information about you permits us to provide you with a smooth, efficient, and customized experience. We may use information collected about you to:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Facilitate your enrollment in the 6-Week Body Reset Challenge.</li>
                <li>Process payments securely via Stripe.</li>
                <li>Monitor your progress and provide daily accountability during the program.</li>
                <li>Send you protocol-related reminders, updates, and coaching communications.</li>
              </ul>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">4. Data Security</h2>
              <p>
                We implement strict physical, electronic, and procedural safeguards to protect your information from unauthorized access or disclosure. Payment data is processed by Stripe and is never stored on our servers.
              </p>
            </section>
            <section>
              <h2 className="text-2xl font-bold text-slate-900 mb-4 font-serif">5. Contact Us</h2>
              <p>If you have questions or comments about this Privacy Policy, please contact us at:</p>
              <ul className="list-none mt-4 space-y-1">
                <li><strong className="text-slate-900 font-semibold">Business:</strong> MyMD Weight Loss</li>
                <li><strong className="text-slate-900 font-semibold">Website:</strong> <a href="https://joinmymd.com" className="text-amber-700 underline">joinmymd.com</a></li>
                <li><strong className="text-slate-900 font-semibold">Email:</strong> <a href="mailto:support@joinmymd.com" className="text-amber-700 underline">support@joinmymd.com</a></li>
                <li><strong className="text-slate-900 font-semibold">Phone:</strong> <a href="tel:2512352120" className="text-amber-700 underline">251-235-2120</a></li>
                <li><strong className="text-slate-900 font-semibold">Mail:</strong> 7250 Pierson Dr, Mobile, AL 36619</li>
              </ul>
            </section>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;